// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"1920b82c","599":"6f6f026c"}[chunkId] + ".chunk.css";
};